// =========================================================
// * Vuetify Material Dashboard PRO - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import router from './router'
import store from './store/index'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
// import './plugins/vue-world-map'
import i18n from './i18n'
import axios from 'axios'
import { localize } from 'vee-validate'
import es from 'vee-validate/dist/locale/es.json'
import Toast from 'vue-toastification'
import Permissions from './mixins/Permissions'
import GuardarBtn from './mixins/GuardarBoton'
import 'vue-toastification/dist/index.css'
import vuetify from './plugins/vuetify'
import App from './App.vue'

import './plugins/dayjsLocale'

localize('es', es)
Vue.use(Toast)
Vue.mixin(Permissions)
Vue.mixin(GuardarBtn)
// window.$ = window.jQuery = require('jquery')
// window.Permissions = store.state.permission.Permissions

Vue.config.productionTip = false
Vue.prototype.$http = axios

window.api = store.apiService

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.loggedIn) {
      next({
        name: 'login',
      })
    } else if (!to.meta.permission) {
      next()
    } else if (to.meta.permission) {
        // await store.dispatch('permission/getPermission', { id: store.state.idUsuario })
        if ((store.state.permission.permissions.indexOf(to.meta.permission)) > -1) {
          next()
        } else {
          next({
            name: 'permission-denied',
          })
        }
    } else {
      next({
        name: '404',
      })
    }
  } else {
    next() // make sure to always call next()!
  }
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
